import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { forwardRef, useImperativeHandle } from "react";
import { Slide, Grid, Button, StepLabel, Stepper, withStyles, StepConnector, makeStyles, Step } from "@material-ui/core";
import Check from "@material-ui/icons/Check";
import clsx from "clsx";
var QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)"
  },
  active: {
    "& $line": {
      borderColor: "#77ffb5"
    }
  },
  completed: {
    "& $line": {
      borderColor: "#77ffb5"
    }
  },
  line: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1
  }
})(StepConnector);
var useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center"
  },
  active: {
    color: "#77ffb5"
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor"
  },
  completed: {
    color: "#77ffb5",
    zIndex: 1,
    fontSize: 18
  }
});

var QontoStepIcon = function QontoStepIcon(props) {
  var classes = useQontoStepIconStyles();
  var active = props.active,
      completed = props.completed;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.root, _defineProperty({}, classes.active, active))
  }, completed ? /*#__PURE__*/React.createElement(Check, {
    className: classes.completed
  }) : /*#__PURE__*/React.createElement("div", {
    className: classes.circle
  }));
};

var HorizontalStepperTemplate = forwardRef(function (props, ref) {
  var _React$useState = React.useState(props.step || 0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeStep = _React$useState2[0],
      setActiveStep = _React$useState2[1];

  var _React$useState3 = React.useState("left"),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      directionStep = _React$useState4[0],
      setDirectionStep = _React$useState4[1]; // const classes = useStyles();


  useImperativeHandle(ref, function () {
    return {
      handleActionStepper: function handleActionStepper(method, value) {
        if (method === "next_step") {
          handleNext();
        } else if (method === "previous_step") {
          handleBack();
        } else if (method === "reset") {
          handleReset();
        }
      }
    };
  });
  var contentSteps = [],
      actionsSteps; // Funcion resetear

  var handleReset = function handleReset() {
    setActiveStep(0);
  }; // Funcion avanzar


  var handleNext = function handleNext() {
    setDirectionStep("left");
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
  }; // Funcion retroceder


  var handleBack = function handleBack() {
    setDirectionStep("right");
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
  };

  contentSteps = props.contentSteps.map(function (contentStep, index) {
    return /*#__PURE__*/React.createElement(Slide, {
      direction: directionStep,
      "in": true,
      mountOnEnter: true,
      unmountOnExit: true,
      key: "slide_step_" + index
    }, contentStep);
  });
  actionsSteps = props.actionsSteps.map(function (actionStep) {
    return actionStep;
  });
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justify: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Stepper, {
    alternativeLabel: true,
    activeStep: activeStep,
    connector: /*#__PURE__*/React.createElement(QontoConnector, null)
  }, props.steps.map(function (label) {
    return /*#__PURE__*/React.createElement(Step, {
      key: label
    }, /*#__PURE__*/React.createElement(StepLabel, {
      StepIconComponent: QontoStepIcon
    }, label));
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      minHeight: "40vh"
    }
  }, contentSteps[activeStep]), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      marginTop: "16px"
    }
  }, actionsSteps[activeStep]));
});
// NECESSARY TO ADD REFFERENCE TO USE THIS COMPONENT
export { HorizontalStepperTemplate };